import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import StatementPreferencePage from "components/pages/StatementPreferencePage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureEStatementsEnrollEPreferences(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    
    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <StatementPreferencePage />
}